import React from 'react'
import BannerMainImageSection from '../../../bannerMainImageSection'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import * as E from '../homeElements'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IEstimateToBeReviewedStageProps } from '../stages/interfaces/IEstimateToBeReviewedStageProps'
import { checkConsultant } from 'helpers'

const EstimateToBeReviewedStage = (props: IEstimateToBeReviewedStageProps) => {
  const { firstName, bannerContent, estimateLink, finAppUrl } = props

  return (
    <>
      <BannerMainImageSection>
        <E.WhiteHeading>Oly novated LEASE</E.WhiteHeading>
        <h1 style={{color:'#fff'}}>Ready to jump into the driver&rsquo;s seat?</h1>
      </BannerMainImageSection>

      <BannerBrandImageSection id="maincontent">
        <E.ContainerBlock>
          <E.BannerButtonLinkParent>
            <Col style={{ maxWidth: '65%' }}>
              <E.BannerButtonTitleRow>Hi {firstName},</E.BannerButtonTitleRow>
              <Row>
                {bannerContent}
              </Row>
            </Col>
            <E.BannerButtonLinkChild>
              <Link to={estimateLink}>
                <E.BannerPrimaryButton extendInMob>
                  View my estimates
                </E.BannerPrimaryButton>
              </Link>
              {finAppUrl != '' && (
                <a>
                  <br />
                  <br />
                    { !checkConsultant() &&
                    <Link
                      to={{ pathname: finAppUrl }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <E.BannerPrimaryInverted extendInMob invertColor>
                        Start finance application
                      </E.BannerPrimaryInverted>
                    </Link>
                    }
                    { checkConsultant() &&
                      <E.BannerPrimaryButton
                        extendInMob
                        id="estimatetobereviewedstage.finapplink"
                        disabled
                      >
                        Start finance application
                      </E.BannerPrimaryButton>
                    }
                </a>
              )}
            </E.BannerButtonLinkChild>
          </E.BannerButtonLinkParent>
        </E.ContainerBlock>
      </BannerBrandImageSection>
    </>
  )
}

export default EstimateToBeReviewedStage
